import Vue from 'vue'
import { language } from '@/infrastructure/Configuration'
import { translate, DateFactory } from 'rhg-vue-common'

export const toPoints = function (points) {
  if (!points) return null
  return translate('boNumPoints', points, points.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
}

export const toDate = function (date) {
  if (!date) {
    return null
  }

  if (language.includes('zh')) {
    return DateFactory.formatDate(date, DateFactory.DatePatterns.CHINESE)
  }

  const formattedDate = DateFactory.formatWithLocaleDate(date, DateFactory.DatePatterns.GENERAL, language.split('-')[0])

  return formattedDate
    .toLowerCase()
    .replace(/\./g, '')
    .split(' ')
    .map(word => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
    .join(' ')
}

export const toAMPM = function (stringNonAMPM) {
  if (!stringNonAMPM || stringNonAMPM.length < 4 || stringNonAMPM.indexOf(':') === -1) {
    return stringNonAMPM
  }

  const splitted = stringNonAMPM.split(':')
  if (splitted.length !== 2 || isNaN(parseInt(splitted[0])) || isNaN(parseInt(splitted[1]))) {
    return stringNonAMPM
  }

  const h = parseInt(splitted[0])
  const m = parseInt(splitted[1])

  const hour = h % 12 ? language !== 'tr' ? h % 12 : h % 24 : 12
  const minute = m < 10 ? '0' + m : m
  if (language === 'tr') {
    return hour + ':' + minute
  }

  const ampm = h >= 12 ? 'PM' : 'AM'

  return hour + ':' + minute + ' ' + ampm
}

export const percentageDiscount = function (price) {
  return ((1 - (price.amount / price.undiscountedAmount)) * 100).toFixed(0)
}

export const pointsPercentageDiscount = function (pointsExtended) {
  return ((1 - (pointsExtended.points / pointsExtended.undiscountedPoints)) * 100).toFixed(0)
}

export const distanceFromDownTown = function (distance) {
  return translate('rdMilesKmFromDowntown', undefined, distance.miles.toFixed(2), distance.km.toFixed(2))
}

Vue.filter('toPoints', toPoints)
Vue.filter('toDate', toDate)
Vue.filter('toAMPM', toAMPM)
Vue.filter('percentageDiscount', percentageDiscount)
Vue.filter('pointsPercentageDiscount', pointsPercentageDiscount)
Vue.filter('distanceFromDownTown', distanceFromDownTown)
